export const PLP_DECIMALS = 18;
export const PALM_DECIMALS = 18;
export const PERCENT_DECIMALS = 18;
